import React, { Component } from "react";
import { translate } from "react-i18next";
import swal from 'sweetalert';

import BreadcrumbTitle from "../../components/BreadcrumbTitle";

import { donorsId, fieldSettings, functionalCriterial, offeringCellsId, offeringCellsSave, offeringCellsUpdate } from "../../libs/services";
import Toolbar from '../components/toolbar/Register'
import AddressData from "../components/AddressData";
import AvatarInfo from "./AvatarInfo";
import DonationData from "./DonationData";
import DonorData from "./DonorData";
import PatientData from "./PatientData";
import ButtonForm from "../../components/ButtonForm";
import { isValidForm } from "../../libs/functions";
import moment from "moment";

class FormBank extends Component{
    constructor(props){
        super(props);

        this.validateInput = this.validateInput.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getInfo = this.getInfo.bind(this);
        this.updateFingerprint = this.updateFingerprint.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.setAvatarData = this.setAvatarData.bind(this);
        this.clearData = this.clearData.bind(this);
        this.isValidAge = this.isValidAge.bind(this);
        this.getData = this.getData.bind(this);

        this.state = {
            can_edit:true,
            blockFields:false,
            blockFieldsPatient:false,
            checkEditData:false,
            fields:[],
            don_hue_dig:{value:'NO'},
            finger_image:"",
            fmd:"",
            hc_status:"",
            from_agenda:false,
            stats:{
                lookup_group:"",
                lookup_rh:"",
                status_bar_color:"",
                total_donations:0,
                date_label:"",
                last_donation_date:"",
                donation_type:"",
                extraction_type:"",
                total_offers:"",
                total_last_year:"",
                donor_status:""
            },
            offer_id:"",
            donor_number:"",
            show_patient_data:false,
            id:"",
            saved:false,
            concent_key:'',
            identification_key:'DONOR_IDENTIFICATION_CARD_CELLS',
            alerts_age_donor:{},
            sv_status:'',
            bio_Status:'',
            flag_samples:false,
            type:'',
        }
    }

    async componentDidMount(){
        if(this.props.location.pathname.indexOf('cell_bank') !== -1){
            this.setState({type:'CELLS'})
        }
        var response = await fieldSettings('OFFERS');
        if(response){
            response.map((res)=>{
                if(res.key === 'NAMES' || res.key === 'EMAIL' || res.key === 'SCHOLARSHIP' ||
                    res.key === 'JOB_PROFILE' || res.key === 'POSTAL_CODE' || 
                    res.key === 'MUNICIPIO' || res.key === 'ESTADO'
                ){
                    res.col = 4;
                }else if(res.key === 'STREET'){
                    res.col = 12;
                }else{
                    res.col = 2;
                }

            })
            this.setState({ fields: response });
        }

        response = await functionalCriterial('don_hue_dig');
        if(response){
            this.setState({ don_hue_dig: response });
        }

        response = await functionalCriterial('ALERTS_AGE_DONOR');
        if(response){
            this.setState({alerts_age_donor: response});
        }

        if(this.props.match.params.id){
            await this.props.waiting.handleShow('Cargando...');
            this.setState({id:this.props.match.params.id});
            
            await this.getData(this.props.match.params.id);
            await this.props.waiting.handleClose();
        }
    }

    async getData(id){
        let response = await offeringCellsId(id);
        if(response){
            await this.donation_data.setData(response);

            this.setState({
                blockFields:true, 
                checkEditData:true, 
                offer_id:response.offering_cells.id,
                sv_status: response.sv_status,
                bio_status: response.bio_status,
                flag_samples:response.flag_samples
            });

            await this.getInfo(response.data_donor.donor.id);
            await this.donor_data.setState({
                mother_data:response.offering_cells.mother_data,
            });

            if(this.patient_data !== undefined){
                await this.patient_data.setData(response.data_patient);
                await this.patient_data.setState({
                    relationship:response.offering_cells.patient_relationship,
                    patient_id:response.offering_cells.patient_id,
                    national_name:response.offering_cells.health_service,
                    national_center_id:response.offering_cells.national_center_id,
                    disablePatient:true,
                    edit_patient:true
                });
            }
            
        }
    }

    validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async getInfo(id){
        if(id !== "" && id !== undefined){
            var response = await donorsId(id);
            if(response !== undefined){
                if(response !== "" && response !== null){
                    this.setState({checkEditData:true})
					this.donor_data.setData(response);

                    if(response.address !== null){
                        this.address_data.setData(response);
                    }
                    
                    this.setAvatarData(response);

                    if(response.last_donation !== null){
                        this.setState({
                            concent_key: response.last_donation.extraction_type === 'MÉDULA ÓSEA' ? 'INFORMED_CONSENT_MED' :
                                        response.last_donation.extraction_type === 'SANGRE PERIFÉRICA' ? 'INFORMED_CONSENT_SP' :
                                        response.last_donation.extraction_type === 'SANGRE PLACENTARIA' ? 'INFORMED_CONSENT_SPL' : ''
                        });
                    }
				}
            }
		}
    }
   
    updateFingerprint(image, fmd){
		this.setState({finger_image:image, fmd:fmd});
	}

    async onSave(){
        var errors = [];

    	if(!isValidForm('div.register-form')) {
    		errors.push('Campos Incompletos');
	    }

        if(this.state.stats.donor_status === 'REJECT'){
            swal('¡Error!', 'El donador tiene estatus de rechazo', 'error');
            return;
        }

        var obj = {
            offering_cells:{
                donor_id:this.donor_data.state.donor_id
            },
            donor:{
                person:{
                    lookup_group:this.state.stats.lookup_group,
                    lookup_rh:this.state.stats.lookup_rh,
                    id:this.donor_data.state.person_id,
                    address_id:this.address_data.state.address_id
                },
                person_id:this.donor_data.state.person_id,
                donor_number:this.donor_data.state.donor_number,
                id:this.donor_data.state.donor_id,
            },
            address:{
                id:this.address_data.state.address_id
            },
            answers:[],
            patient:{},
            photo: "",
            fingerprint: this.state.fmd,
            fingerprint_img: this.state.finger_image
        }

        obj = this.donation_data.getData(obj);
        obj = this.donor_data.getData(obj);
        obj = this.address_data.getData(obj);
        obj = this.avatar_info.getData(obj);

        if(this.patient_data !== undefined){
            obj = {...obj, offering_cells:{
                ...obj.offering_cells,
                patient_id:this.patient_data.state.patient_id
            },patient:{
                ...obj.patient,
                id:this.patient_data.state.patient_id
            }};

            if(this.patient_data.state.patient_id !== ""){
                obj = {...obj, patient:{
                    ...obj.patient,
                    person:{
                        ...obj.patient.person,
                        id:this.patient_data.state.person_id
                    }
                }};
            }
        }

        if(this.state.id !== ""){
            obj = {...obj, offering_cells:{
                ...obj.offering_cells,
                id:this.state.id                
            }};
        }

        if(obj.donor.person.birthday === 'invalid date'){
            errors.push('Fecha de nacimiento de donante no valida');
        }

        var index = this.state.fields.findIndex(obj => 
            obj.key === 'DONOR_PHONE' && obj.required
        );

        if(index !== -1){
            if(obj.donor.person.phones.length === 0){
                errors.push("Debe agregar por lo menos un número de teléfono");
            }
        }

        var mpio = document.getElementById('MUNICIPIO');
        if(mpio  !== null){
            if(mpio.value !== "" && obj.address.municipio === ""){
                errors.push('No se seleccionó un municipio del catálogo');
                document.getElementById('MUNICIPIO').classList.add('error');
            }
        }

        if(this.state.show_patient_data){
            obj = this.patient_data.getData(obj);

            if(obj.patient.person.birthday === 'invalid date'){
                errors.push('Fecha de nacimiento de paciente no valida');
            }
        }
        
        if(errors.length === 0){
            this.isValidAge(obj);
        }else{
            var msg = "<div class='col-xs-12'>";
            msg += "<h4>Se encontraron algunos errores</h4>";
            msg += "<div class='col-xs-12'><ul>";
			for(var i =0;i < errors.length;i++){
				msg+="<li style='color:red;text-align:left;'>"+errors[i]+"</li>";
			}
			msg += '</ul></div></div>';

			swal({
		        title: 'Error',
		        html:true,
		        text: msg,
		        type: 'error'
		    });
        }
	
    }

    isValidAge(obj){
        var items = this.donation_data.state.donation_types;
        var donation_type_id = obj.offer !== undefined ? obj.offer.donation_type_id : obj.offering_cells.donation_type_id;
        var donor_age = obj.offer !== undefined ? obj.offer.donor_age : obj.offering_cells.donor_age;
        var valid = false;

        var index = items.findIndex(item => item.rules.donation_type_id === parseInt(donation_type_id));
        
        if(index !== -1){
            
            if(donor_age < items[index].rules.age_min || donor_age > items[index].rules.age_max){
                
                if(this.state.alerts_age_donor.value === 'YES'){
                    return swal({
                        title:"¡Valores fuera de rango!\n ¿Desea guardar?",
                        text:"La edad de donación permitida es de "+items[index].rules.age_min+" a "+items[index].rules.age_max+" años.",
                        type: 'warning',
				        showCancelButton: true,                        
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true,
                    },(confirm)=>{
                        if(confirm){
                            this.saving(obj);
                        }
                    });
                }
            }else{
                this.saving(obj);
            }
        }

        
    }

    async saving(obj){
        var response;
        if(this.state.id === ""){
            response = await offeringCellsSave(obj, this.props.waiting);
        }else{
            response = await offeringCellsUpdate(this.state.id, obj, this.props.waiting);
        }
        
        if(response){
            this.setState({
                saved:true, 
                id:response.offering_cells_id
            });

            this.getData(response.offering_cells_id)
        }  
    }

    onCancel(){
        this.props.history.goBack();
    }

    setAvatarData(response){
        this.setState({
            stats:{
                lookup_group:response.person.lookup_group,
                lookup_rh:response.person.lookup_rh,
                status_bar_color:response.donor_status === 'REJECT' ? 'red':
                        response.donor_status === 'ACCEPT' ? 'green' : 'lightgray',
                status:response.status_message,
                total_donations:0,
                date_label:"",
                last_donation_date:response.last_donation !== null ?  moment(response.last_donation.date).format('DD/MM/YYYY') : '',
                donation_type:response.last_donation !== null ? response.last_donation.type : '',
                extraction_type:response.last_donation !== null ? response.last_donation.extraction_type : '',
                total_offers:"",
                total_last_year:"",
                donor_status: response.donor_status
            },
            donor_number:response.donor.donor_number
        });

        if(response.person.photo !== "" && response.person.photo !== null){
            this.avatar_info.setState({photo:'data:image/jpeg;base64,'+response.person.photo});
        }        

        if(response.phones.length > 0){    
            this.avatar_info.phone_data.setState({phonesAdded:response.phones});
        }
    }

    clearData(){
        this.setState({
            inger_image:"",
            fmd:"",
            hc_status:"",
            stats:{
                lookup_group:"",
                lookup_rh:"",
                status_bar_color:"",
                total_donations:0,
                date_label:"",
                last_donation_date:"",
                donation_type:"",
                extraction_type:"",
                total_offers:"",
                total_last_year:"",
                donor_status:""
            },
            offer_id:"",
            donor_number:"",
            id:"",
            sv_status:'',
            bio_Status:'',
            blockFields:false,
        });
        this.donor_data.clearData();
        this.address_data.clearData();
        this.avatar_info.clearData();
    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
                <BreadcrumbTitle 
                    menu={t('sidebar.nav.donors.MAIN')}
                    page={this.state.id !== "" ? 'Editar Registro de Células' : "Nuevo Registro de Células"}
                />

                <div className="col-xs-12 col-sm-9 no-padding register-form">
                    <div className="col-xs-12 form-group">
                        <DonationData 
                            {...this.props}
                            title="Datos del Predonante"
                            validate={this.validateInput}
                            can_edit={this.state.can_edit}
                            onChange={this.handleChange}
                            getInfo={this.getInfo}
                            clearData={this.clearData}
                            setInfoDonor={this.setInfoDonor}
                            don_hue_dig={this.state.don_hue_dig}
                            onRef={ref => this.donation_data = ref}
                        />                    
                    </div>
                    <div className="col-xs-12">
                        <DonorData
                            {...this.props}
                            validate={this.validateInput}
                            checkEditData={this.state.checkEditData}
                            blockFields={this.state.blockFields}
                            onChange={this.handleChange}
                            fields={this.state.fields}
                            onRef={ref => this.donor_data = ref}
                        />
                    </div>
                    <div className="col-xs-12 form-group">
                        <AddressData 
                            {...this.props}
                            validate={this.validateInput}
                            blockFields={this.state.blockFields}
                            fields={this.state.fields}
                            onRef={ref => this.address_data = ref}
                        />
                    </div>

                    {this.state.show_patient_data &&
                        <PatientData
                            {...this.props}
                            blockFieldsPatient={this.state.blockFieldsPatient}
                            fields={this.state.fields}
                            onChange={this.handleChange}
                            setInfoPatient={this.setInfoPatient}
                            validate={this.validateInput}
                            onRef={ref => this.patient_data = ref}
                        />
                    }

                    {<div className="col-xs-12 form-group">
                        <Toolbar
                            {...this.props}
                            disabled={!this.state.blockFields || this.state.id === ""}
                            samples={true}
                            vitalSigns={true}
                            biometrics={true}
                            clinicHistory={true}
                            labels={true}
                            printConsent={true}
                            notes={false}
                            identityCard={true}
                            variables={{
                                labels:'direct',
                                donor:{
                                    name:this.donor_data !== undefined ?
                                            (this.donor_data.state.lastname1 + this.donor_data.state.lastname2 + this.donor_data.state.names)
                                        : '',
                                    donation_number:this.state.id,
                                    date:this.donation_data !== undefined ? this.donation_data.state.timestamp : '',
                                    sex:this.donor_data !== undefined ? this.donor_data.state.sex : '',
                                    id:this.donor_data !== undefined ? this.donor_data.state.donor_id : ''
                                },
                                label_key:'label_register_cells', 
                                concent_key:this.state.concent_key,
                                identification_key: this.state.identification_key,
                                id:this.state.id,
                                action_hc:'go',
                                sv_status:this.state.sv_status,
                                bio_status:this.state.bio_status,
                                flag_samples:this.state.flag_samples,
                                clinic_history:'/cell_bank/clinic_history/CELLS/'+this.state.id,
                                type:this.state.type
                            }}
                            onRef={ref => this.toolbar = ref}
                        />
                    </div>}
                    <div className="col-xs-12 form-group" style={{textAlign:'center'}}>
                        {!this.state.saved?
                            <>
                                <ButtonForm 
                                    label={t('content.generics.buttons.save')} 
                                    action={this.onSave}
                                />
                                <ButtonForm 
                                    label={t('content.generics.buttons.reset')} 
                                    action={this.onCancel}
                                />
                            </>
                        :
                            <>
                                <ButtonForm 
                                    label={t('content.generics.buttons.finish')} 
                                    action={this.onCancel}
                                />
                            </>	
                        }
                    </div>
                </div>
                <div className="col-xs-12 col-sm-3 no-padding">
                    <AvatarInfo 
                        {...this.props}
                        fields={this.state.fields}
                        hc_status={this.state.hc_status}
                        from_agenda={this.state.from_agenda}
                        don_hue_dig={this.state.don_hue_dig}
                        stats={this.state.stats}
                        offer_id={this.state.offer_id}
                        donor_number={this.state.donor_number}
                        finger_image={this.state.finger_image}                        
                        updateFingerprint={this.updateFingerprint}
                        onRef={ref => this.avatar_info = ref}
                    />
                </div>
                
                
            </div>
        )
    }
}

export default translate('translations')(FormBank);